import React from 'react';
import './Header.css';

const Header = ({ currency, onCurrencyChange, onLogout, showLogout }) => {
  return (
    <header className="header">
      <div className="header-content">
        <div className="header-logo">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="3"></circle>
            <path d="M12 2v3M12 19v3M2 12h3M19 12h3"></path>
            <path d="M5 5l2 2M17 17l2 2M5 19l2-2M17 7l2-2"></path>
          </svg>
          <h1>ирмис - админ панель</h1>
        </div>
        <div className="header-controls">
          {onCurrencyChange && (
            <div className="currency-selector">
              <button
                className={`currency-btn ${currency === 'USD' ? 'active' : ''}`}
                onClick={() => onCurrencyChange('USD')}
              >
                $ USD
              </button>
              <button
                className={`currency-btn ${currency === 'RUB' ? 'active' : ''}`}
                onClick={() => onCurrencyChange('RUB')}
              >
                ₽ RUB
              </button>
            </div>
          )}
          
          {showLogout && (
            <button className="logout-btn" onClick={onLogout} title="Выйти">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                <polyline points="16 17 21 12 16 7"></polyline>
                <line x1="21" y1="12" x2="9" y2="12"></line>
              </svg>
            </button>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
